// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","container":"Card_container__3BCzV","image":"Card_image__3KnJq","arrow":"Card_arrow__2jWAc"};